export default {
  methods: {
    renderChangeTrend(data, selectedTypes = []) {
      if (!this.$refs.changeTrend) return;

      // 定义类型映射关系
      const typeMap = {
        '价格相关': { name: '价格变更', dataKey: 'priceChange', color: '#50D387' },
        '设计图': { name: '设计图', dataKey: 'design', color: '#FF9800' },
        '发货周期': { name: '发货周期', dataKey: 'delivery', color: '#F46950' },
        '销售状态': { name: '销售状态', dataKey: 'salesStatus', color: '#00D1C8' },
        'SKU推广名称': { name: 'SKU推广名称', dataKey: 'skuPromotion', color: '#F6D763' },
        '通栏图': { name: '通栏图', dataKey: 'fullWidthQty', color: '#975fe4' },
        '是否松木': { name: '是否松木', dataKey: 'pineQty', color: '#E91E63' }
      };

      // 判断是否全选（包含空字符串表示全选）
      const isSelectAll = selectedTypes.includes('') || selectedTypes.length === 0;
      
      // 根据选中的类型过滤要显示的系列
      const typesToShow = isSelectAll 
        ? Object.keys(typeMap) 
        : selectedTypes.filter(type => typeMap[type]);

      // 动态生成图例数据
      const legendData = typesToShow.map(type => typeMap[type].name);

      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line',
            lineStyle: {
              color: '#ccc',
              width: 1,
              type: [5, 10]
            },
            crossStyle: {
              color: '#ccc'
            }
          },
        },
        legend: {
          data: legendData,
          textStyle: {
            color: '#fff',
            fontSize: 12,
            fontFamily: 'PingFangSC',
          },
          top: 10,
        },
        grid: {
          left: '2%',
          right: '1%',
          bottom: '4%',
          containLabel: true,
        },
        dataZoom: [
          {
            type: 'inside',
            xAxisIndex: [0],
            start: 0,
            end: Math.min(100, (12 / Math.max(data.months.length, 1)) * 100)
          }
        ],
        xAxis: {
          type: 'category',
          data: data.months,
          axisLabel: {
            color: '#fff',
            fontSize: 12,
            fontFamily: 'PingFangSC'
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(255,255,255,0.2)'
            }
          },
          axisTick: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            lineStyle: {
              color: '#7BFFE0',
            },
          },
          axisLabel: {
            color: '#fff',
            fontSize: 12,
            fontFamily: 'PingFangSC',
          },
          splitLine: {
            // lineStyle: {
            //   color: 'rgba(123, 255, 224, 0.2)',
            // },
            show: false
          },
        },
        series: typesToShow.map(type => {
          const config = typeMap[type];
          const seriesData = data[config.dataKey] || [];
          // 当只有一个数据点时显示圆点
          const showSymbol = seriesData.length === 1;
          return {
            name: config.name,
            type: 'line',
            data: seriesData,
            smooth: true,
            showSymbol: showSymbol,
            // symbolSize: 8, // 设置圆点大小
            lineStyle: {
              color: config.color,
              width: 2,
            },
            itemStyle: {
              color: config.color,
            },
          };
        }),
      };

      const $instance = this.$echarts.init(this.$refs.changeTrend);
      this.$refs.changeTrend.removeAttribute('_echarts_instance_');
      $instance.setOption(option);
      window.onresize = $instance.resize;
    }
  }
}
